export interface IUserInfo {
  name: string
  email: string
  phone: string
  location: string
}

export const emptyui: IUserInfo = {
  name: '',
  email: '',
  phone: '',
  location: ''
}
